import React, {useCallback, useEffect, useState} from "react";
import axios from "axios";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import "./HomeFeed.css";
import * as AppConfig from '../../app/config/constants'
import HandlInfoCard from "../../components/modules/home/HandlInfoCard";
import InsuranceSearchCard from "../../components/modules/home/InsuranceSearchCard";
import Loading from "../../components/modules/Loading";
import ProfileCompletionCard from "../../components/modules/home/ProfileCompletionCard";
import VersatileLinkCard from "../../components/modules/home/VersatileLinkCard";
import useAuthApi from "../../hooks/useAuthApi";
import {MemoizedUserNavigation} from "../../components/sections/Navigation";


function HomeFeed(props) {
  const [smallScreen, setSmallScreen] = useState(false);
  const [userZipcode, setUserZipcode] = useState("");
  const [fullName, setFullName] = useState("");
  const [profileCompletionPercentage, setProfileCompletionPercentage] = useState("");
  const [nextToComplete, setNextToComplete] = useState([]);
  const [articles, setArticles] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const location = useLocation();
  const authApi = useAuthApi()

  const userID = useSelector((state) => state?.user_data?.user_data?.id);

  // useEffect(() => {
  //   fetchArticleData();
  // }, []);

  useEffect(() => {
    if (
      !fullName
      // articles?.length < 1 ||
      // profileCompletionPercentage === ""
    )
      return;
    setLoaded(true);
  }, [articles, fullName, profileCompletionPercentage]);

  useEffect(() => {
    if (!userID) return;
    getUserInformation(userID);
  }, [userID]);

  // This function determines whethr the user is view the page on a small screen on load and anytime the screen resizes
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 768) {
        setSmallScreen(true);
      } else {
        setSmallScreen(false);
      }
    }
    handleResize();
    window.addEventListener("resize", handleResize);
  }, [setSmallScreen]);

  // get user info based on user id
  const getUserInformation = useCallback( (user_id)=> {
    authApi.get("users/user_informations/" + user_id).then((data) => {
      console.log('getUserInformation:')
      console.log(data)
        const userInformation = data.data.attributes;
        setUserZipcode(
          userInformation.zip_code ? userInformation.zip_code.zip_codes : ""
        );
        setFullName(userInformation?.full_name && userInformation.full_name);
        setProfileCompletionPercentage(
          userInformation?.completion && userInformation.completion
        );
        setNextToComplete(
          userInformation?.next_to_complete && userInformation.next_to_complete
        );
        setLoaded(true)
      }).catch(console.log);
  }, [setUserZipcode, setFullName, setProfileCompletionPercentage, setNextToComplete, setLoaded])

  async function fetchArticleData() {
    let env;
    AppConfig.API_BASE_URI.includes("localhost")
      ? (env = "local")
      : AppConfig.API_BASE_URI.includes("staging")
      ? (env = "staging")
      : (env = "production");

    const url = AppConfig.API_BASE_URI + "articles";
    const request = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${AppConfig.API_KEY}`,
      },
      params: {
        env: env,
      },
    });
    setArticles(request.data.data);
  }

  const state = {
    from: location.pathname,
    userID: userID,
    userZipcode: userZipcode,
    searchActive: true,
    smallScreen: smallScreen,
  };

  const MobileStatsCard = (title, body, marginAdjustment = false) => {
    return (
      <Link
        to={title === "Appointments" ? "/appointments" : "/settings/my-profile"}
      >
        <div
          className="flex mobile-stats-card"
          style={marginAdjustment === true ? { marginBottom: "-10%" } : {}}
        >
          <p className="text-large dark-blue fw-500">{title}</p>
          <p className="text-medium">{body}</p>
        </div>
      </Link>
    );
  };

  return loaded === true ? (
    <>
      <MemoizedUserNavigation />
      <div className="home-container">
        <div className="grid-container homefeed">
          {smallScreen === false && (
            <div>
              <ProfileCompletionCard
                fullName={fullName}
                smallScreen={smallScreen}
                profileCompletionPercentage={profileCompletionPercentage}
                nextToComplete={nextToComplete}
                setProfileCompletionPercentage={setProfileCompletionPercentage}
              />
              <VersatileLinkCard
                smallScreen={smallScreen}
                title={"Ready to book?"}
                bodyText="Choose from a saved estimate or search a new service"
                buttonLabel={"find new estimate"}
                link={"/providers"}
                state={state}
              />
            </div>
          )}
          <div className="homefeed-right-container">
            {smallScreen && (
              <div className="mobile-stats-card-container">
                {MobileStatsCard(
                  "Profile",
                  `${
                    profileCompletionPercentage && profileCompletionPercentage
                  }% complete`,
                  true
                )}
              </div>
            )}
            <div className="grid-card">
              <HandlInfoCard smallScreen={smallScreen} />
            </div>
            <div
              style={smallScreen ? { paddingInline: "16px" } : {}}
              className="grid-card"
            >
              <InsuranceSearchCard smallScreen={smallScreen} state={state} />
            </div>
          </div>
        </div>
      </div>
    </>
  ) : (
    <Loading />
  );
}

export default HomeFeed;
